// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--42660";
export var icons = "footer-module--icons--ddb5d";
export var legal = "footer-module--legal--7f37a";
export var quickLinks = "footer-module--quick-links--b9d9f";